import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { api } from "@/lib/api";
import { Eyebrow, Spinner, StatusPill } from "@/components/tac";

const STATUS_TONE = { draft: "scheduled", sent: "en_route", accepted: "completed", declined: "none" };

export default function Quotes() {
  const [quotes, setQuotes] = useState(null);
  useEffect(() => { api.get("/quotes").then((r) => setQuotes(r.data)).catch(() => setQuotes([])); }, []);
  if (!quotes) return <div className="p-8"><Spinner /></div>;
  return (
    <div className="mx-auto max-w-4xl p-6" data-testid="quotes-page">
      <Eyebrow>Sales</Eyebrow>
      <h1 className="mt-2 flex items-center gap-2 font-display text-3xl font-bold text-white"><FileText className="h-7 w-7 text-[#2E7BE4]" /> Quotes</h1>
      <p className="mt-2 text-slate-400">Build, send and track customer quotes and deposits.</p>
      <div className="mt-6 space-y-2">
        {quotes.length === 0 && <p className="card-tac p-6 text-center text-slate-500">No quotes yet. Create one from a job's AI estimate.</p>}
        {quotes.map((q) => (
          <Link key={q.id} to={`/quotes/${q.id}`} data-testid={`quote-link-${q.id}`}
            className="card-tac flex items-center justify-between p-4 transition-colors hover:border-[#2E7BE4]/60">
            <div>
              <div className="font-display font-semibold text-white">{q.number}</div>
              <div className="font-mono-tac text-[11px] text-slate-500">{q.customer_name || "No customer"} · {(q.line_items || []).length} items</div>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-display text-lg font-bold text-white">${(q.total || 0).toFixed(2)}</span>
              <StatusPill status={STATUS_TONE[q.status] || "scheduled"} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
